import styled from 'styled-components'
export const SubMenuItem = styled.div`
  display: flex;
  flex-direction: column;
  button {
    padding-left: 25px;
    align-self: flex-start;
  }
`
